<template>
  <section class="account-usage-summary" aria-label="Your usage" aria-live="polite">
    <template v-if="usage">
      <div class="usage-primary"><strong>{{ usage.label }}: {{ usage.value }}</strong><span v-if="usage.reserved"> · {{ usage.reserved }} reserved</span></div>
      <p>{{ usage.description }}</p>
      <p v-if="usage.paidPlan && usage.previewText"><strong>{{ usage.previewLabel }}:</strong> {{ usage.previewText }}</p>
      <p v-else-if="usage.previewText">{{ usage.previewText }}</p>
      <p v-if="usage.renewalDate">{{ usage.renewalLabel }} {{ usage.renewalDate }}.</p>
      <p v-if="usage.availabilityMessage" role="status">{{ usage.availabilityMessage }}</p>
      <p v-if="usage.warning" role="status">{{ usage.warning.text }}</p>
      <!-- Optional app content inside the same card, such as a plan offer. -->
      <slot/>
      <v-btn v-if="usage.status==='error'" small outlined @click="$emit('retry')">Retry allowance</v-btn>
    </template>
  </section>
</template>
<script>
export default {name:'AccountUsageSummary',props:{usage:{type:Object,default:null}}};
</script>
<style scoped>
.account-usage-summary{padding:18px 20px;background:var(--bg-secondary,#f0f5eb);border:1px solid var(--border-input,#dbe4d4);border-radius:9px;margin:14px 0;color:var(--text-primary,#274b3c)}
.usage-primary{font-size:16px}.account-usage-summary p{font-size:13px;line-height:1.6;margin:8px 0 0}
</style>
